import { render, staticRenderFns } from "./Questionpaper.vue?vue&type=template&id=2dba2556"
import script from "./Questionpaper.vue?vue&type=script&lang=js"
export * from "./Questionpaper.vue?vue&type=script&lang=js"
import style0 from "./Questionpaper.vue?vue&type=style&index=0&id=2dba2556&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports